<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31">
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <g>
          <g>
            <g>
              <g>
                <path fill="#164194" d="M0 0L0 27.5 9.167 27.5 9.167 25.208 11.458 25.208 11.458 27.5 27.5 27.5 27.5 6.875 20.625 6.875 20.625 0z" transform="translate(-1027 -391) translate(127 318) translate(855 3) translate(45 70) translate(1.25 1.25)" />
                <path
                  fill="#E1F5FE"
                  d="M20.625 9.166H25.209V25.207H20.625zM18.333 2.292L2.292 2.292 2.292 25.208 6.875 25.208 6.875 22.917 13.75 22.917 13.75 25.208 13.75 25.209 18.333 25.209z"
                  transform="translate(-1027 -391) translate(127 318) translate(855 3) translate(45 70) translate(1.25 1.25)"
                />
                <path fill="#164194" d="M4.583 13.75H6.875V16.041H4.583zM9.167 13.75H11.458V16.041H9.167z" transform="translate(-1027 -391) translate(127 318) translate(855 3) translate(45 70) translate(1.25 1.25)" />
                <path
                  fill="#13A2E8"
                  d="M11.78 4.584L9.46 4.583 9.46 6.875 6.875 6.875 6.875 4.583 4.583 4.583 4.583 6.875 4.583 9.167 4.583 11.458 6.875 11.458 6.875 9.167 9.509 9.167 9.509 11.458 11.73 11.459z"
                  transform="translate(-1027 -391) translate(127 318) translate(855 3) translate(45 70) translate(1.25 1.25)"
                />
                <path
                  fill="#164194"
                  d="M13.75 13.75H16.042V16.041H13.75zM13.75 9.167H16.042V11.459H13.75zM13.75 4.583H16.042V6.875H13.75zM4.583 18.334H6.875V20.625H4.583zM9.167 18.334H11.458V20.625H9.167zM13.75 18.334H16.042V20.625H13.75z"
                  transform="translate(-1027 -391) translate(127 318) translate(855 3) translate(45 70) translate(1.25 1.25)"
                />
                <path fill="#13A2E8" d="M20.625 20.625H22.917V22.917H20.625zM20.625 16.041H22.917V18.333H20.625zM20.625 11.458H22.917V13.75H20.625z" transform="translate(-1027 -391) translate(127 318) translate(855 3) translate(45 70) translate(1.25 1.25)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>